<template>
    <div class="alta-container">
      <h2 class="mb-4">{{ editando ? 'Editar' : 'Crear' }} Punto de Abastecimiento</h2>
  
      <!-- Formulario para crear/editar Punto de Abastecimiento -->
      <div class="card shadow-sm p-3 mb-4 bg-white rounded">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre del Punto</label>
          <input type="text" v-model="puntoAbastecimientoLocal.nombre" class="form-control" placeholder="Ingrese el nombre" />
        </div>
  
        <div class="mb-3">
          <label for="ubicacion" class="form-label">Ubicación</label>
          <select v-model="puntoAbastecimientoLocal.ubicacion_id" class="form-select">
            <option v-for="ubicacion in ubicaciones" :key="ubicacion.id" :value="ubicacion.id">
              {{ formatearUbicacion(ubicacion) }}
            </option>
          </select>
        </div>
  
        <div class="mb-3">
          <label for="nivelExactitud" class="form-label">Nivel de Exactitud</label>
          <select v-model="puntoAbastecimientoLocal.nivelExactitud" class="form-select">
            <option value="PAIS">País</option>
            <option value="REGION">Región/Provincia</option>
            <option value="CIUDAD">Ciudad</option>
            <option value="DISTRITO">Distrito/Barrio</option>
            <option value="CALLE">Calle</option>
          </select>
        </div>
  
        <div class="form-check mb-3">
          <input type="checkbox" v-model="puntoAbastecimientoLocal.visible" class="form-check-input" id="visible" />
          <label class="form-check-label" for="visible">¿Hacer Visible al Público?</label>
        </div>
  
        <button class="btn btn-primary me-2" @click="guardarPuntoAbastecimiento">Guardar Punto</button>
        <button class="btn btn-secondary" @click="resetFormulario">Cancelar</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      puntoAbastecimiento: Object,  // Recibimos el punto de abastecimiento como prop
      ubicaciones: Array, // Recibimos las ubicaciones como prop
      editando: Boolean,  // Modo de edición
      club_id: Number,
    },
    data() {
      return {
        puntoAbastecimientoLocal: { ...this.puntoAbastecimiento }, // Clonamos el prop en una variable local
      };
    },
    watch: {
      // Cuando el prop 'puntoAbastecimiento' cambia, actualizamos la copia local
      puntoAbastecimiento: {
        immediate: true,
        handler(newValue) {
          this.puntoAbastecimientoLocal = { ...newValue };
        },
      },
    },
    methods: {
      formatearUbicacion(ubicacion) {
        return `${ubicacion.pais}, ${ubicacion.region}, ${ubicacion.ciudad}`;
      },
  
      // Guardar un punto de abastecimiento
      async guardarPuntoAbastecimiento() {
        try {
            this.puntoAbastecimientoLocal.club_id = this.club_id;
            this.puntoAbastecimientoLocal.nivel_exactitud=this.puntoAbastecimientoLocal.nivelExactitud;
          // Emitimos los datos al componente padre, usando la copia local

          this.$emit('guardar', this.puntoAbastecimientoLocal);
          this.resetFormulario();
        } catch (error) {
          console.error('Error al guardar el punto de abastecimiento:', error);
        }
      },
  
      // Resetear el formulario
      resetFormulario() {
        this.$emit('reset'); // Emitimos el evento para resetear el formulario en el componente padre
      },
    },
  };
  </script>
  